import * as React from "react";
import {Range, SleepAsync, Timer} from "js-vextensions";
import Moment from "moment";
import {Button, CheckBox, Column, Row, Spinner, Text, TextArea} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {TimelineRow} from "../../UI/Timeline/Timeline/TimelineRow.js";
import {GetFBAccessToken, PostImageToFacebook} from "../../Utils/Services/Facebook.js";
import {PostImageToGooglePlus} from "../../Utils/Services/GooglePlus.js";
import {dataURItoBlob, TakeScreenshot} from "../../Utils/UI/ScreenshotTaker.js";
import {AddTimelineEvent, StopCurrentTimelineEvents} from "../../Server/Commands/TimelineEventCommands.js";
import {store} from "../../Store/index.js";
import {User} from "../../Server/DB/users/@User.js";
import {Observer, RunInAction, RunInAction_Set, useForceUpdate} from "web-vcore";
import {runInAction} from "mobx";
import {GetActivities} from "../../Server/DB/activities.js";
import {Activity} from "../../Server/DB/activities/@Activity.js";
import {TimelineEvent} from "../../Server/DB/timelineEvents/@TimelineEvent.js";
import {MeID} from "../../Server/DB/users.js";
import {observer_mgl} from "mobx-graphlink";
import {useEffect, useState} from "react";

function CalculateMainTimes(days: number, dayShift = 0) {
	var now = Moment();
	if (dayShift != 0) {
		now = now.add(dayShift, "days");
	}

	var rangeStart = now.clone().startOf("day").subtract(days, "day");
	var rangeEnd = now.clone().endOf("day");
	var dayStart = now.clone().startOf("day");
	//var dayEnd = now.clone().endOf("day");
	var dayEnd = dayStart.clone().add(1, "day");
	return {now, rangeStart, rangeEnd, dayStart, dayEnd};
}

export const TimelineUI = observer_mgl((props: {user: User})=>{
	const {user} = props;
	const uiState = store.main.timeline;
	const [shareToFB, setShareToFB] = useState(true);
	const [shareToGP, setShareToGP] = useState(true);

	const activities = GetActivities(MeID());
	const timeRanges = CalculateMainTimes(uiState.daysToShow, uiState.dayShift);
	const {now, rangeStart, rangeEnd, dayStart, dayEnd} = timeRanges;

	const forceUpdate = useForceUpdate();
	useEffect(()=>{
		const refreshTimer = new Timer(60 * 1000, ()=>forceUpdate()).Start();
		return ()=>refreshTimer.Stop();
	}, []);

	const rows = [] as React.JSX.Element[];
	for (let offset = -(uiState.daysToShow - 1); offset <= 0; offset++) {
		const startTime = dayStart.clone().add(offset, "days");
		const endTime = dayEnd.clone().add(offset, "days");
		rows.push(
			<TimelineRow key={startTime.toString()} {...{timelineID: user.id!, startTime: startTime.valueOf(), endTime: endTime.valueOf(),
				index: rows.length, last: offset == 0}}/>,
		);
	}

	return (
		<Row style={{height: "100%"}}>
			<Column id="graph" style={{
				position: "relative", /*margin: "20px auto 20px auto",*/ flex: 1,
				height: uiState.screenshotMode ? "" : "100%",
				background: "rgba(0,0,0,.3)",
				filter: "drop-shadow(rgb(0, 0, 0) 0px 0px 10px)",
			}}>
				{/*uiState.screenshotMode &&
					<Row style={{padding: 10}}>
						<Row style={{fontSize: 25, fontWeight: 500, color: "white"}}>Lucid Frontier</Row>
						{activities.map((activity, index)=>{
							return (
								<Row key={index} ml={index == 0 ? "auto" : 10} style={{padding: 7, background: `rgba(${activity.color})`, border: "1px solid black", color: "white"}}>
									{activity.name}
								</Row>
							);
						})}
					</Row>*/}
				<Header timeRanges={timeRanges} screenshotMode={uiState.screenshotMode}/>
				{/*uiState.screenshotMode && rows}
				{!uiState.screenshotMode &&
					<ScrollView style={{flex: 1}} contentStyle={{flex: 1}}>
						{rows}
					</ScrollView>*/}
				<ScrollView style={{flex: 1}} contentStyle={{flex: 1}}>
					{rows}
				</ScrollView>
			</Column>
			<Column style={{width: 300, height: "100%", padding: 5, background: "rgba(0,0,0,.5)"}}>
				<Column>
					<Row ml={3}>Set current activity:</Row>
					<Column mt={5}>
						{activities.map((activity, index)=>{
							return <Button key={index} text={activity.name} mt={index ? 5 : 0} onClick={async()=>{
								await new StopCurrentTimelineEvents({timelineID: user.id!}).RunOnServer();
								const event = new TimelineEvent({timeline: user.id, activity: activity.id, startTime: Date.now()});
								new AddTimelineEvent({entry: event}).RunOnServer();
							}}/>;
						})}
						<Button text="None" mt={5} onClick={()=>{
							new StopCurrentTimelineEvents({timelineID: user.id!}).RunOnServer();
						}}/>
					</Column>
					{/*<Row ml={3} mt={10}>Actions:</Row>*/}
					<div style={{marginTop: 7, height: 1, background: "rgba(255,255,255,.3)"}}/>
					<Column mt={5}>
						<Row>
							<Text>Days to show: </Text>
							<Spinner min={-Infinity} value={uiState.daysToShow} onChange={val=>RunInAction_Set(()=>uiState.daysToShow = val)}/>
						</Row>
						<Row>
							<Text>Day shift: </Text>
							<Spinner min={-Infinity} value={uiState.dayShift} onChange={val=>RunInAction_Set(()=>uiState.dayShift = val)}/>
							<Button ml={5} text="<" onClick={()=>RunInAction_Set(()=>uiState.dayShift = uiState.dayShift - 1)}/>
							<Button ml={5} text=">" onClick={()=>RunInAction_Set(()=>uiState.dayShift = uiState.dayShift + 1)}/>
						</Row>
						<Row>
							<Text>Row height: </Text>
							<Spinner min={-Infinity} value={uiState.rowHeight} onChange={val=>RunInAction_Set(()=>uiState.rowHeight = val)}/>
						</Row>
						<Row>
							<Text>Sleep-schedule mode: </Text>
							<CheckBox value={uiState.specialDisplayMode == "sleepSchedule"} onChange={val=>RunInAction_Set(()=>uiState.specialDisplayMode = val ? "sleepSchedule" : null)}/>
						</Row>
						<Row>
							<Text>Visualization mode: </Text>
							<CheckBox value={uiState.specialDisplayMode == "visualization"} onChange={val=>RunInAction_Set(()=>uiState.specialDisplayMode = val ? "visualization" : null)}/>
						</Row>
						<Row>
							<Text>Screenshot mode: </Text>
							<CheckBox value={uiState.screenshotMode} onChange={val=>RunInAction_Set(()=>uiState.screenshotMode = val)}/>
						</Row>
						<Row><Text>Message:</Text></Row>
						<Row>
							<TextArea value={uiState.message} onChange={val=>RunInAction("Timeline.message.onChange", ()=>uiState.message = val)}/>
						</Row>
						<Row mt={5}>
							<Text>Share to: </Text>
							<CheckBox text="Facebook" value={shareToFB} onChange={val=>setShareToFB(val)}/>
							<CheckBox ml={5} text="Google+" value={shareToGP} onChange={val=>setShareToGP(val)}/>
						</Row>
						<Button text="Take screenshot and share" mt={5} onClick={async()=>{
							RunInAction_Set(()=>uiState.screenshotMode = true);
							await SleepAsync(1000);
							const screenshotDataURI = await TakeScreenshot(document.querySelector("#graph"));
							RunInAction_Set(()=>uiState.screenshotMode = false);

							//window.open(screenshot, "_blank");
							//window.open(screenshot);

							if (shareToFB) {
								/*const screenshotBlob = dataURItoBlob(screenshotDataURI);
								const fbToken = await GetFBAccessToken();
								await PostImageToFacebook(fbToken, "3000 Weeks - Graph", "image/png", screenshotBlob, message);*/
								await PostImageToFacebook(screenshotDataURI, uiState.message);
							}

							if (shareToGP) {
								await PostImageToGooglePlus(screenshotDataURI, uiState.message);
							}
						}}/>
					</Column>
				</Column>
			</Column>
		</Row>
	);
});

class Header extends BaseComponent<{timeRanges: any, screenshotMode: boolean}, {}> {
	/*refreshTimer: Timer;
	ComponentDidMount() {
		// refresh header every minute
		this.refreshTimer = new Timer(60 * 1000, ()=>this.Update()).Start();
	}
	ComponentWillUnmount() {
		this.refreshTimer.Stop();
	}*/

	render() {
		const {timeRanges, screenshotMode} = this.props;
		const {now, rangeStart, rangeEnd, dayStart, dayEnd} = timeRanges;

		const currentPercentThroughDay = now.diff(dayStart) / dayEnd.diff(dayStart);
		return (
			<div style={{position: "relative", height: 20, borderBottom: "1px solid rgba(255,255,255,.3)"}}>
				{Range(0, 23).map(hour=>{
					return (
						<Row key={hour} style={{position: "absolute", left: `${(hour / 24) * 100}%`, height: "100%"}}>
							<div style={{width: 1, height: "100%", background: "rgba(128,128,128,.25)"}}/>
							<div style={{marginLeft: 3, fontSize: 11}}>{hour}</div>
						</Row>
					);
				})}
				{!screenshotMode &&
					<div style={{position: "absolute", left: `calc(${currentPercentThroughDay * 100}% - 10px)`, width: 20, height: "100%"}}>
						<div className="triangle down" style={{backgroundColor: "rgba(200,200,200,1)"}}/>
					</div>}
			</div>
		);
	}
}